export const profileconfig = {
        distributor: {
            2: {
                fields: [
                    {
                        label: "Contact Person",
                        type: "Label"
                    }
                    ,
                    {
                        label: "First Name",
                         label2: "First Name",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "firstName",
                        size: "large",
                        name: "firstName",
                        key: "firstName",
                        errorMessage:"Enter your First Name",
                        require:true
                    },
                    {
                        label: "Last Name",
                        type: "Text",
                        label2: "Last Name",
                        itemclass: "form-elemnt",
                        id: "lastname",
                        size: "large",
                        name: "lastName",
                        key: "lastName",
                        errorMessage:"Enter your Last Name",
                        require:true
                    },
                    {
                        label: "Phone Number",
                        type: "Phone",
                        label2: "Phone Number",
                        itemclass: "form-elemnt",
                        id: "regPhone",
                        size: "large",
                        name: "mobileNumber",
                        key: "phoneNumber",
                        errorMessage:"Enter your Phone Number",
                        require:true
                    },
                    {
                        label: "Job Title",
                        type: "Text",
                        label2: "Job Title",
                        itemclass: "form-elemnt",
                        id: "jobTitle",
                        size: "large",
                        name: "jobTitle",
                        key: "jobTitle",
                        errorMessage:"Enter your Job Title",
                        require:true
                    },
                    {
                        label: "Department",
                        type: "Text",
                        label2: "Department",
                        itemclass: "form-elemnt",
                        id: "jobTitle",
                        size: "large",
                        name: "department",
                        key: "department",
                        errorMessage:"Enter your Department",
                        require:true
                    },
                    {
                        label: "Company Name",
                        label2: "Company Name",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "companyName",
                        size: "large",
                        name: "comapnyname",
                        key: "companyName",
                        errorMessage:"Enter your Company Name",
                        require:true
                    },
                    {
                        label: "Next",
                        type: "button",
                        itemclass: "submit-item",
                        id: "submit",
                        size: "large",
                        name: "department",
                        key: "department",
                        elementclass: "submit-btn",
                    }

                ]

            },
            3: {
                fields: [
                    {
                        label: "Company Details",
                        type: "Label"
                    },
                    {
                        label: "Company Name",
                        label2: "Company Name",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "companyName",
                        size: "large",
                        name: "comapnyname",
                        key: "companyName",
                        errorMessage:"Enter your Company Name",
                        require:true
                    },
                    {
                        label: "Number of Employees",
                        label2: "Number of Employees",
                        type: "Number",
                        itemclass: "form-elemnt",
                        id: "numberofEmployee",
                        size: "large",
                        name: "numberofEmployee",
                        key: "numberOfEmployees",
                        errorMessage:"Enter your Number of Employees",
                        require:true
                    },
                    {
                        label: "Company Website",
                        type: "Text",
                        label2: "Company Website",
                        itemclass: "form-elemnt",
                        id: "companyWebiste",
                        size: "large",
                        name: "companyWebsite",
                        key: "companyWebsite",
                        errorMessage:"Enter your Company Website",
                        require:true
                    },
                    {
                        label: "Company Phone No",
                        label2: "Company Phone No",
                        type: "Phone",
                        itemclass: "form-elemnt",
                        id: "companyPhone",
                        size: "large",
                        name: "compnayPhone",
                        key: "compnayPhone",
                        errorMessage:"Enter your Company Phone No",
                        require:true
                    },
                    {
                        label: "Country",
                        label2: "Country",
                        type: "Select",
                        itemclass: "form-elemnt",
                        id: "country",
                        size: "large",
                        name: "country",
                        key: "country",
                        errorMessage:"Enter your Country",
                        require:true
                    },
                    {
                        label: "City",
                        label2: "City",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "city",
                        size: "large",
                        name: "city",
                        key: "city",
                        errorMessage:"Enter your City",
                        require:true
                    },
                    {
                        label: "Street",
                        label2: "Street",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "street",
                        size: "large",
                        name: "street",
                        key: "street",
                        errorMessage:"Enter your Street",
                        require:true
                    },
                    {
                        label: "PO Box/Postal Code",
                        label2: "PO Box/Postal Code",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "pob",
                        size: "large",
                        name: "postalcode",
                        key: "postCode",
                        errorMessage:"Enter your Postal Code",
                        require:true
                    },
                    {
                        label: "Company Trade License",
                        label2: "Company Trade License",
                        type: "Upload",
                        itemclass: "form-elemnt",
                        id: "tradeUpload",
                        size: "large",
                        name: "tradeLicense",
                        key: "tradeLicense",
                        errorMessage:"Attach company Trade License",
                        require:true
                    },
                    {
                        label: "Company tax. registration ( TRN Certificate )",
                        label2: "Company tax. registration ( TRN Certificate )",
                        type: "Upload",
                        itemclass: "form-elemnt",
                        id: "tax_upload",
                        size: "large",
                        name: "trnCertificate",
                        key: "trnCertificate",
                        errorMessage:"Attach Company tax. registration document",
                        require:true
                    },
                    {
                        label: "Next",
                        type: "button",
                        itemclass: "submit-item",
                        id: "submit",
                        size: "large",
                        name: "",
                        key: "",
                        elementclass: "submit-btn",
                    }
                ]
            },
            4: {
                fields: [
                    {

                        label: "Billing Details",
                        type: "Label"

                    },
                    {
                        label: "First Name",
                        label2: "First Name (Billing)",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "firstName_billing",
                        size: "large",
                        name: "firstName_billing",
                        key: "firstName",
                        errorMessage:"Enter your First Name",
                        require:true
                    },
                    {
                        label: "Last Name",
                        type: "Text",
                        label2: "Last Name (Billing)",
                        itemclass: "form-elemnt",
                        id: "lastName_billing",
                        size: "large",
                        name: "lastName_billing",
                        key: "lastName",
                        errorMessage:"Enter your Last Name",
                        require:true
                    },
                    {
                        label: "Email",
                        label2: "Email (Billing)",
                        type: "email",
                        itemclass: "form-elemnt",
                        id: "email_billing",
                        size: "large",
                        name: "email_billing",
                        key: "email",
                        errorMessage:"Enter your Email",
                        require:true
                    },
                    {
                        label: "Job Title",
                        label2: "Job Title (Billing)",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "jobTitle_billing",
                        size: "large",
                        name: "jobTitle_billing",
                        key: "jobTitle",
                        errorMessage:"Enter your Job Title",
                        require:true
                    },
                    {
                        label: "Department",
                        label2: "Department (Billing)",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "department_billing",
                        size: "large",
                        name: "department_billing",
                        key: "department",
                        errorMessage:"Enter your Department",
                        require:true
                    },
                    {
                        label: "Phone Number",
                        label2: "Phone Number (Billing)",
                        type: "Phone",
                        itemclass: "form-elemnt",
                        id: "workmail_billing",
                        size: "large",
                        name: "phone_billing",
                        key: "mobileNumber",
                        errorMessage:"Enter your Phone Number",
                        require:true
                    },
                    {
                        label: "Linkedin Profile",
                        label2: "Linkedin Profile (Billing)",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "linkedIn_billing",
                        size: "large",
                        name: "linkedIn_billing",
                        key: "linkedInProfile"
                    },
                    {
                        label: "Next",
                        type: "button",
                        itemclass: "submit-item",
                        id: "submit",
                        size: "large",
                        name: "",
                        key: "",
                        elementclass: "submit-btn",
                    }
                ]
            },
            5: {
                fields: [
                    {

                        label: "Company Authorized Details",
                        type: "Label"

                    },
                    {
                        label: "First Name",
                        label2: "First Name (Authorized)",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "firstName_authorized",
                        size: "large",
                        name: "firstName_authorized",
                        key: "firstName",
                        errorMessage:"Enter your First Name",
                        require:true
                    },
                    {
                        label: "Last Name",
                        label2: "Last Name (Authorized)",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "lastName_authorized",
                        size: "large",
                        name: "lastName_authorized",
                        key: "lastName",
                        errorMessage:"Enter your Last Name",
                        require:true
                    },
                    {
                        label: "Email",
                        label2: "Email (Authorized)",
                        type: "email",
                        itemclass: "form-elemnt",
                        id: "email_authorized",
                        size: "large",
                        name: "email_authorized",
                        key: "email",
                        errorMessage:"Enter your Email",
                        require:true
                    },
                    {
                        label: "Job Title",
                        label2: "Job Title (Authorized)",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "jobTitle_authorized",
                        size: "large",
                        name: "jobTitle_authorized",
                        key: "jobTitle",
                        errorMessage:"Enter your Job Title",
                        require:true
                    },
                    {
                        label: "Department",
                        label2: "Department (Authorized)",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "departmant_authorized",
                        size: "large",
                        name: "departmant_authorized",
                        key: "department",
                        errorMessage:"Enter your Department",
                        require:true
                    },
                    // {
                    //     label: "Phone Number",
                    //     type: "Phone",
                    //     itemclass: "form-elemnt",
                    //     id: "workmail_authorized",
                    //     size: "large",
                    //     name: "phone_authorized",
                    //     key: "mobileNumber",
                    //     errorMessage:"Enter your Phone Number",
                    //     require:true
                    // },
                    {
                        label: "Linkedin Profile",
                        label2: "Linkedin Profile (Authorized)",

                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "linkedIn_authorized",
                        size: "large",
                        name: "linkedIn_authorized",
                        key: "linkedInProfile"
                    },
                    {
                        label: "Complete Registration",
                        type: "button",
                        itemclass: "submit-item",
                        id: "submit",
                        size: "large",
                        name: "",
                        key: "",
                        elementclass: "submit-btn reg-btn",
                    }
                ]
            },
        },
        supplier:{
            2: {
                fields: [
                    {
                        label: "Contact Person",
                        type: "Label"
                    }
                    ,
                    {
                        label: "First Name",
                        label2: "First Name",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "firstName",
                        size: "large",
                        name: "firstName",
                        key: "firstName",
                        errorMessage:"Enter your First Name",
                        require:true
                    },
                    {
                        label: "Last Name",
                        label2: "Last Name",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "lastname",
                        size: "large",
                        name: "lastName",
                        key: "lastName",
                        errorMessage:"Enter your Last Name",
                        require:true
                    },
                    {
                        label: "Surname",
                        label2: "Surname",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "regPhone",
                        size: "large",
                        name: "surname",
                        key: "surname",
                        errorMessage:"Enter your Surname",
                        require:true
                    },
                    {
                        label: "Title",
                        label2: "Title",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "title",
                        size: "large",
                        name: "title",
                        key: "title",
                        errorMessage:"Enter your Title",
                        require:true
                    },
                    {
                        label: "Phone Number",
                        label2: "Phone Number",
                        type: "Phone",
                        itemclass: "form-elemnt",
                        id: "regPhone",
                        size: "large",
                        name: "mobileNumber",
                        key: "telephoneNumber",
                        errorMessage:"Enter your Phone Number",
                        require:true
                    },
                    {
                        label: "Job Title",
                        label2: "Job Title",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "jobTitle",
                        size: "large",
                        name: "jobTitle",
                        key: "jobTitle",
                        errorMessage:"Enter your Job Title",
                        require:true
                    },
                    {
                        label: "Company Name",
                        label2: "Company Name",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "companyName",
                        size: "large",
                        name: "comapnyname",
                        key: "companyName",
                        errorMessage:"Enter your Company Name",
                        require:true
                    },
                    {
                        label: "Next",
                        type: "button",
                        itemclass: "submit-item",
                        id: "submit",
                        size: "large",
                        name: "department",
                        key: "department",
                        elementclass: "submit-btn",
                    }

                ]

            },
            3:{
                fields: [
                    {
                        label: "Company Details",
                        type: "Label"
                    },
                    {
                        label: "Company Name",
                        label2: "Company Name",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "companyName",
                        size: "large",
                        name: "comapnyname",
                        key: "companyName",
                        errorMessage:"Enter your Company Name",
                        require:true
                    },
                    {
                        label: "Company Website",
                        label2: "Company Website",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "companyWebiste",
                        size: "large",
                        name: "companyWebsite",
                        key: "companyWebsite",
                        errorMessage:"Enter your Company Website",
                        require:true
                    },
                    {
                        label: "Country",
                        label2: "Country",
                        type: "Select",
                        itemclass: "form-elemnt",
                        id: "country",
                        size: "large",
                        name: "country",
                        key: "country",
                        errorMessage:"Enter your Country",
                        require:true
                    },
                    {
                        label: "Vat Country",
                        label2: "Vat Country",
                        type: "Select",
                        itemclass: "form-elemnt",
                        id: "vatcountry",
                        size: "large",
                        name: "vatcountry",
                        key: "vatCountry",
                        errorMessage:"Enter your Vat Country",
                        require:true
                    },
                    {
                        label: "Vat Number",
                        label2: "Vat Number",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "vatNumber",
                        size: "large",
                        name: "Vatnumber",
                        key: "vatNumber",
                        errorMessage:"Enter your vat Number",
                        require:true
                    },
                    {
                        label: "Registration Number",
                        label2: "Registration Number",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "regnumber",
                        size: "large",
                        name: "registrationNumber",
                        key: "registrationNumber",
                        errorMessage:"Enter your Registration Number",
                        require:true
                    },
                    {
                        label: "City",
                        label2: "City",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "city",
                        size: "large",
                        name: "city",
                        key: "city",
                        errorMessage:"Enter your City",
                        require:true
                    },
                    {
                        label: "Street",
                        label2: "Street",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "street",
                        size: "large",
                        name: "street",
                        key: "street",
                        errorMessage:"Enter your Street",
                        require:true
                    },
                    {
                        label: "PO Box/Postal Code",
                        label2: "PO Box/Postal Code",
                        type: "Text",
                        itemclass: "form-elemnt",
                        id: "pob",
                        size: "large",
                        name: "postalcode",
                        key: "postCode",
                        errorMessage:"Enter your PO Box/Postal Code",
                        require:true
                    },
                    {
                        label: "Gmp Certificate",
                        label2: "Gmp Certificate",
                        type: "Upload",
                        itemclass: "form-elemnt",
                        id: "gmpCertficate",
                        size: "large",
                        name: "gmpCertficate",
                        key: "gmpCertficate",
                        errorMessage:"Enter your Gmp Certificate",
                        require:true
                    },
                    {
                        label: "Manufacturing Certificate",
                        label2: "Manufacturing Certificate",
                        type: "Upload",
                        itemclass: "form-elemnt",
                        id: "manufacturingLicense",
                        size: "large",
                        name: "manufacturingLicense",
                        key: "manufacturingLicense",
                        errorMessage:"Enter your Manufacturing Certificate",
                        require:true
                    },
                    {
                        label: "List of Manufacturing Products",
                        label2: "List of Manufacturing Products",
                        type: "Upload",
                        itemclass: "form-elemnt",
                        id: "listOfManufacturedMedicinces",
                        size: "large",
                        name: "listOfManufacturedMedicinces",
                        key: "listOfManufacturedMedicinces",
                        errorMessage:"Enter your Manufacturing Products",
                        require:true
                    },
                    {
                        label: "List of Site Master File",
                        label2: "List of Site Master File",
                        type: "Upload",
                        itemclass: "form-elemnt",
                        id: "siteMasterFile",
                        size: "large",
                        name: "siteMasterFile",
                        key: "siteMasterFile",
                        errorMessage:"Enter your List of Site Master File",
                        require:true
                    },
                    {
                        label: "List of detail company Profile",
                        label2: "List of detail company Profile",
                        type: "Upload",
                        itemclass: "form-elemnt",
                        id: "detailedCompanyProfile",
                        size: "large",
                        name: "detailedCompanyProfile",
                        key: "detailedCompanyProfile",
                        errorMessage:"Enter your List of detail company Profile",
                        require:true
                    },
                    {
                        label: "List of Certificate of Registration",
                        label2: "List of Certificate of Registration",
                        type: "Upload",
                        itemclass: "form-elemnt",
                        id: "certificatesOfRegistration",
                        size: "large",
                        name: "certificatesOfRegistration",
                        key: "certificatesOfRegistration",
                        errorMessage:"Enter your List of Certificate of Registration",
                        require:true
                    }
                    ,
                    {
                        label: "List of Manufacuring Goods",
                        label2: "List of Manufacuring Goods",
                        type: "Upload",
                        itemclass: "form-elemnt",
                        id: "certificatesOfGoodManufacturingPractices",
                        size: "large",
                        name: "certificatesOfGoodManufacturingPractices",
                        key: "certificatesOfGoodManufacturingPractices",
                        errorMessage:"Enter your List of Manufacuring Goods",
                        require:true
                    },
                    {
                        label: "Next",
                        type: "button",
                        itemclass: "submit-item",
                        id: "submit",
                        size: "large",
                        name: "department",
                        key: "department",
                        elementclass: "submit-btn",
                    }

                ]

            },
            4:{
                fields:[{
                    label: "Person Invoice",
                    type: "Label"
                }
                ,
                {
                    label: "First Name",
                    label2: "First Name (Invoice)",
                    type: "Text",
                    itemclass: "form-elemnt",
                    id: "firstName_authorized",
                    size: "large",
                    name: "firstName_authorized",
                    key: "firstName",
                    errorMessage:"Enter your First Name",
                        require:true
                },
                {
                    label: "Last Name",
                    label2: "Last Name (Invoice)",
                    type: "Text",
                    itemclass: "form-elemnt",
                    id: "lastName_authorized",
                    size: "large",
                    name: "lastName_authorized",
                    key: "surname",
                    errorMessage:"Enter your Last Name",
                        require:true
                },
                {
                    label: "Email",
                    type: "email",
                    label2: "Email (Invoice)",
                    itemclass: "form-elemnt",
                    id: "email_authorized",
                    size: "large",
                    name: "email_authorized",
                    key: "email",
                    errorMessage:"Enter your Email",
                        require:true
                },
                {
                    label: "Job Title",
                    label2: "Job Title (Invoice)",
                    type: "Text",
                    itemclass: "form-elemnt",
                    id: "jobTitle_authorized",
                    size: "large",
                    name: "jobTitle_authorized",
                    key: "jobTitle",
                    errorMessage:"Enter your Job Title",
                    require:true
                },
                {
                    label: "Phone No",
                    label2: "Phone No (Invoice)",
                    type: "Phone",
                    itemclass: "form-elemnt",
                    id: "phone_authorized",
                    size: "large",
                    name: "phone_authorized",
                    key: "telephoneNumber",
                    errorMessage:"Enter your Phone No",
                        require:true
                },
                {
                    label: "Country",
                    label2: "Country (Invoice)",
                    type: "Select",
                    itemclass: "form-elemnt",
                    id: "invoicePersonCountry",
                    size: "large",
                    name: "invoicePersonCountry",
                    key: "country",
                    errorMessage:"Enter your Country",
                        require:true
                    
                },
                {
                    label: "Postal Code",
                    label2: "Postal Code (Invoice)",
                    type: "Text",
                    itemclass: "form-elemnt",
                    id: "personPostal",
                    size: "large",
                    name: "personPostal",
                    key: "postCode",
                    errorMessage:"Enter your Postal Code",
                        require:true
                },
                {
                    label: "Complete Registration",
                    type: "button",
                    itemclass: "submit-item",
                    id: "submit",
                    size: "large",
                    name: "",
                    key: "",
                    elementclass: "submit-btn reg-btn",
                }
                ]

            }
        }

};
